/**
* Scrolling Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'scrolling-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let topOffset = $( 'header' ).height() + 40;
      if ( $( 'body.logged-in' ).length > 0 ) {
        topOffset += 32;
      }
      if ( $( window ).width() > '768' && $( '.scrolling-cards_content' ).length > 0 ) {
        const marginTop = '-' + ( 32 + $( '.scrolling-cards_hider' ).outerHeight() ) + 'px';
        $( '.scrolling-cards_hider' ).css( 'margin-top', marginTop );

        $( 'section.scrolling-cards' ).each( function() {
          const st = ScrollTrigger.create( {
            trigger: $( this ),
            pin: $( this ).find( '.scrolling-cards_content' ),
            start: 'top top+='+ topOffset +'px',
            end: 'bottom bottom',
            scrub: 3,
            // markers: true,
            id: 'content-pin',
            // pinSpacing: false,
            anticipatePin: true,
          } );
        } );
      }
      let sectionHeight = 0;
      if ( $( window ).width() > '768' && $( '.scrolling-cards_card' ).length > 0 ) {
        $( '.scrolling-cards_card' ).each( function() {
          sectionHeight = sectionHeight + $( this ).height();
          const cards = gsap.timeline( {
            scrollTrigger: {
              trigger: $( this ),
              pin: false,
              start: 'top bottom',
              end: 'top center',
              scrub: 3,
              // markers: true,
            },
          } );
          // cards.from( $( this ), {opacity: 0, y: 80} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'scrolling-cards', COMPONENT );
} )( app );
